module.exports = __webpack_public_path__ + "static/media/ARROZL_MENU-normal.e4aba284.png";